import React, { PureComponent } from 'react'
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import LimitContainerDetail from './LimitContainerDetail'
import { cannabisRule, consumerTypes } from '../../../utils/common'
import { RemoveRedEye } from '@material-ui/icons'

export default class LimitContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedKey: null,
    }
  }

  handleItemClick = (limit) => {
    this.setState({ selectedKey: this.state.selectedKey === limit.key ? null : limit.key })
  }

  groupItemsByDisplayName = (limits = []) => {
    return Object.entries(
      limits.reduce((acc, item) => {
        const displayName =
          item.displayMetadata && item.displayMetadata.displayName
            ? item.displayMetadata.displayName
            : ''
        acc[displayName] = acc[displayName] || []
        acc[displayName].push(item)
        return acc
      }, {}),
    )
  }

  ruleValue = (rules) => {
    return rules
      .map((rule) => {
        const ruleName = cannabisRule.find((item) => item.value === rule)
        return ruleName && ruleName.label ? ruleName.label : ''
      })
      .filter(Boolean)
      .join(', ')
  }

  render() {
    const { selectedKey } = this.state
    const { limits = [] } = this.props

    const groupedItems = this.groupItemsByDisplayName(limits.limits)
    const customerType = consumerTypes.find((type) => type.value === limits.consumerType)
    const customerTypeDisplayName = customerType && customerType.label ? customerType.label : ''

    const CellStyle = {
      fontSize: '14px'
    }

    return (
      <Card style={{ margin: '20px 0px', padding: '10px 30px' }}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <h2>{customerTypeDisplayName}</h2>
        </Grid>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ ...CellStyle, width: '45%' }}>Cannabis Type</TableCell>
              <TableCell style={{ ...CellStyle, width: '15%' }}>Period</TableCell>
              <TableCell style={{ ...CellStyle, width: '15%' }}>State Limits</TableCell>
              <TableCell style={{ ...CellStyle, width: '25%' }}>Rules</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupedItems.map(([key, items]) =>
              items.map((limit, index) => (
                <React.Fragment key={`${key}-${index}`}>
                  <TableRow
                    hover
                    selected={selectedKey === limit.key}
                    onClick={index === 0 ? () => this.handleItemClick(limit) : undefined}
                  >
                    <TableCell style={CellStyle}>
                      {index === 0 && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <RemoveRedEye
                            style={{ marginRight: '5px', color: 'gray', fontSize: '16px' }}
                          />
                          {key}
                        </div>
                      )}
                    </TableCell>
                    <TableCell style={CellStyle}>
                      {
                        limit.time === 0 ? 
                        'Transactional' 
                        : (limit.time === 1 ? 'Daily' : `${limit.time} days`)
                      }
                    </TableCell>
                    <TableCell style={CellStyle}>{`${limit.max} ${limit.customUomAbbrev}`}</TableCell>
                    <TableCell style={CellStyle}>{this.ruleValue(limit.tags)}</TableCell>
                  </TableRow>
                  {selectedKey === limit.key && index === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} style={CellStyle}>
                        <LimitContainerDetail limitDetail={limit} />
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              )),
            )}
          </TableBody>
        </Table>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LimitV2/LimitContainer.js